import React from "react";
import { featuresLeft, featuresRight } from "../Data/ComponentsData/componentsdata";
import { Container, Row, Col } from "reactstrap";

const Features = () => {
  return (
    <section className='theme-bg feature' id='feature'>
      <Container>
        <div className='animation-circle-inverse'>
          <i></i>
          <i></i>
          <i></i>
        </div>
        <Row>
          <Col md='12' className='text-center'>
            <div className='section-title'>
              <h2 className='text-white'>Chat Loop Feature</h2>
              <img src='assets/images/white-line.png' alt='white-line' className='img-fluid' />
            </div>
          </Col>
          <Col lg='4' sm='6' className="position-relative">
            <div className='future-box text-end'>
              <div className='future-timeline'>
                <ul>
                  {featuresLeft.map((feature, index) => (
                    <li className='timeline' key={index}>
                      <h4 className='sub-title'>{feature.title}</h4>
                      <p>{feature.description}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Col>
          <Col md='4' className='future-mobile z-1'>
            <img src='assets/images/feature-mob.png' alt='feature-mob' className='img-fluid' />
          </Col>
          <Col lg='4' sm='6' className="position-relative">
            <div className='future-box text-strat'>
              <div className='future-timeline-right'>
                <ul className='text-left'>
                  {featuresRight.map((feature, index) => (
                    <li className='timeline-right' key={index}>
                      <h4>{feature.title}</h4>
                      <p>{feature.description}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Features;
